import { currentTimeMillis, formatTimestamp } from '@nu-art/ts-common';
const relativeFormatter = new Intl.RelativeTimeFormat('en', { numeric: 'always' });
const DIVISIONS = [
    { amount: 60, unit: 'seconds' },
    { amount: 60, unit: 'minutes' },
    { amount: 24, unit: 'hours' },
    { amount: 7, unit: 'days' },
    { amount: 4.34524, unit: 'weeks' }, // average weeks per month
    { amount: 12, unit: 'months' },
];
export const formatRelativeTime = (timestamp) => {
    if (!Number.isFinite(timestamp))
        return '';
    // Clamp future timestamps (client clock skew / imported data) to now — "edited" is never in the future.
    let duration = Math.min(timestamp - currentTimeMillis(), 0) / 1000; // seconds; negative = past
    if (Math.abs(duration) < 5)
        return 'just now';
    for (const division of DIVISIONS) {
        if (Math.abs(duration) < division.amount)
            return relativeFormatter.format(Math.round(duration), division.unit);
        duration /= division.amount;
    }
    return relativeFormatter.format(Math.round(duration), 'years');
};
export const formatCreated = (timestamp) => Number.isFinite(timestamp) ? formatTimestamp('MMM D, YYYY', timestamp) : '';
/**
 * created = main.__created; lastEdited = max(__updated) across the main entity and all its building blocks.
 * Returns undefined for entities without a valid creation timestamp (e.g. new/preview items not yet saved).
 * Non-finite building-block timestamps are ignored so a single missing value can't break formatting.
 */
export const computeEntityTimestamps = (main, ...buildingBlocks) => {
    if (!Number.isFinite(main.__created))
        return undefined;
    const created = main.__created;
    const updates = [main, ...buildingBlocks.flat()]
        .map(item => item.__updated)
        .filter((value) => Number.isFinite(value));
    return {
        created,
        // max includes created, so lastEdited can never predate creation (e.g. migrated data)
        lastEdited: Math.max(created, ...updates),
    };
};
//# sourceMappingURL=entity-timestamps.js.map